import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'roblex-right-page-content',
    templateUrl: './right-page-content.component.html',
    styleUrls: ['./right-page-content.component.scss'],
    host: {
        class: 'container h-100 d-flex flex-column position-relative'
    }
})
export class RightPageContentComponent implements OnInit {
    @Input() positionFixed = true;
    @Input() alignItemsCenter!: boolean;

    constructor() {
    }

    ngOnInit(): void {
        // console.warn('RightPageContentComponent');
    }

}
